export default "<div class=\"m-2\"><app-crm-stat-procedure></app-crm-stat-procedure></div>\r\n"